import isEmpty from 'lodash/isEmpty';

export const TeaserBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}) => {
  let dataSaved = {
    ...data,
    [id]: value,
  };

  if (id === 'href' && isEmpty(value)) {
    dataSaved = {
      ...dataSaved,
      title: '',
      description: '',
      preview_image: null,
      head_title: '',
    };
  }

  if (id === 'href' && !isEmpty(value) && !data.title && !data.description) {
    dataSaved = {
      ...dataSaved,
      title: value[0].Title,
      description: value[0].Description,
      head_title: value[0].head_title,
    };
  }
  onChangeBlock(block, dataSaved);
};
